module.exports = {"Domain":"域名","AppProfile":"專案","OriginPolicy":"回源政策","HtmlPage":"HTML頁面","WafRule":"WAF規則","Cert":"憑證","ServiceGroup":"站點","SLB":"SLBS","VSLB":"虛擬SLBS","EDGE":"EDGES","DomainsWithAppProfile":"應用配置內的域名"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/resourceType.json
// module id = UTVV
// module chunks = 3